<template>
  <div>
    <el-menu class="menu" :default-active="activeIndex" @select="handleSelect" mode="horizontal"
      background-color="#5489FF" text-color="#A9C4FF" text-size="36px"
      active-text-color="white">
      <div class="nav-img">
        <img src="@/assets/HAH_LOGO_V3-02.svg" width="116.47px" height="36px">
      </div>
      <el-menu-item index="/patient" :route="{ name: 'PatientBoard', query: { tab: 'total'} }">คนไข้</el-menu-item>
      <el-menu-item index="/caregiver" :route="{ name: 'CaregiverBoard' }">ผู้ดูแล</el-menu-item>
      <el-menu-item index="/chat" :route="{ name: 'ChatBoard' }">แชท</el-menu-item>
      <el-submenu class="submenu profile-item" index="5" mode="vertical" style="color: white;">
        <template slot="title">
          <img v-if="profile.photo" :src="profile.photo" class="nav-profile" width="35px" height="35px">
          <img v-else src="@/assets/avatar-copy@2x.png" width="35px" height="35px">
        </template>
        <el-menu-item class="item text-logout" index="logout">ออกจากระบบ</el-menu-item>
      </el-submenu>
    </el-menu>

    <!-- Logout Dialog -->
      <el-dialog id="logout-dialog" :visible.sync="control.showLogoutDialog" :closeOnClickModal="false" :show-close="false" style="margin-top: 19vh;" width="30%">
        <div style="display: flex; justify-content: row; align-items: center; margin-top: 30px;">
          <img width="38" height="38" src="https://storage.healthathome.in.th/87d115c7-a7c9-48f0-a2c7-23728a96f917.svg" />
          <div class="header-18" style="margin-left: 17px;">คุณต้องการยกเลิกการลา ?</div>
        </div>
        <span class="dialog-footer" slot="footer">
          <el-button class="cancel-button" @click="handleLogoutClick(false)">ยกเลิก</el-button>
          <el-button type="primary" @click="handleLogoutClick(true)">ตกลง</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<style lang="scss">
  .el-menu-item.is-active {
    border-bottom-color: #446BC5 !important;
    background-color: #446BC5 !important;
  }

  .profile-item {
    position: absolute;
    right: 100px;
  }

  .menu {
    padding-left: 100px;
    display: flex;
    flex-direction: row;
  }

  .submenu {
    padding-left: 100px;
    display: flex;
    flex-direction: column;
  }

  .el-menu.menu {
    height: 60px !important;
  }

  .el-menu.el-menu--horizontal {
    border-bottom: 0;
  }

  .el-menu {
    position: fixed;
    width: 100vw;
    height: 48px;
    z-index: 1000;
  }

  .el-menu-item {
    font-family: 'Sukhumvit-SemiBold';
    font-size: 16px;
  }

  .el-menu--horizontal {
    top: 0;
  }

  .el-menu--horizontal .el-menu .el-menu-item {
    padding-left: 28px;
    padding-right: 0px;
  }

  .nav-img {
    padding-top: 11px;
    margin-right: 21.5px;
    margin-left: 20px;
    outline: none;
  }

  .el-menu-item i {
    margin-left: 10px;
    color: #a5d8ff;
    margin-top: 100px;
  }

  .el-submenu__title i {
    color: #a5d8ff;
    font-size: 18px;
    font-weight: 800;
  }

  .item {
    padding-left: 8px;
  }

  .el-menu--collapse .el-menu .el-submenu, .el-menu--popup {
    max-width: 220px;
  }

  .text-logout {
    font-family: 'Sukhumvit-Medium';
    color: #D4E1FF !important;
  }

  .nav-profile {
    border-radius: 50%;
  }

  #logout-dialog {
    .header-18 {
      font-weight: 500;
      font-size: 18px;
      line-height: 29px;
      color: #434B61;
    }

    .cancel-button {
      min-width: 80.92px;
      border: 1.5px solid #409EFF !important;
      transition: .2s;
      span {
        color: #409EFF;
        transition: .2s;
      }
      &:hover {
        background: #409EFF !important;
        transition: .2s;
        span {
          color: #FFFFFF;
          transition: .2s;
        }
      }
    }
  }
</style>

<script>
import { GenericAPIHandler } from './shared/GenericAPIHandler'

export default {
  name: 'Navbar',
  mixins: [GenericAPIHandler],
  watch: {
    '$route' (to, from) {
      this.selectActiveIndex(to.path)
    },
  },
  data () {
    return {
      activeIndex: '',
      profile: {},
      control: {
        showLogoutDialog: false,
      },
    }
  },
  created () {
    const path = window.location.pathname
    this.selectActiveIndex(path)
    this.getProfile()
  },
  methods: {
    selectActiveIndex (path) {
      if (path.startsWith('/patient')) { this.activeIndex = '/patient' }
      if (path.startsWith('/caregiver')) { this.activeIndex = '/caregiver' }
      if (path.startsWith('/chat')) { this.activeIndex = '/chat' }
    },
    handleSelect (key, keyPath) {
      switch (key) {
        case 'logout':
          this.control.showLogoutDialog = true
          break
        case '/patient':
          this.$router.push({ name: 'PatientBoard', query: { tab: 'total' } })
          break
        case '/caregiver':
          this.$router.push({ name: 'CaregiverBoard' })
          break
        case '/chat':
          this.$router.push({ name: 'ChatBoard' })
          break
      }
    },
    async handleLogoutClick (status) {
      if (status) {
        this.$router.push({ path: '/logout' })
      }
      this.control.showLogoutDialog = false
    },
    async getProfile () {
      try {
        this.profile = await this.$api.Auth.profile()
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
  },
}
</script>
